module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAr0lEQVQokZWSsQ0CMQxFn0+pGICSDZgh9a1w9EiwEQOwAUxwlMyABMUNgCiRQnG2yJ0SI75kJfa37B87EmObGCF6mv8AVnwx4RsNyCzhp99kHf5BCg55AZY1Msxk5Ng4RaVxyA7Y1kh7o1mv8R1wBA4a7zTeW651vKkN6j+Bd8a99D6oj8TY1tTcGfdYnIE31T2wqJFBNZeqnp2iyZvqCbh6HWt7XDP9qznEpHoo8h+yDSNL66hZGgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/15c.png
// module id = txIm
// module chunks = 64